import script from "./ViewMyTeams.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewMyTeams.vue?vue&type=script&setup=true&lang=js"

import "./ViewMyTeams.vue?vue&type=style&index=0&id=2610dd27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2610dd27"]])

export default __exports__